import { Box, Text, HeaderPage } from '@backstage/ui';
import { Content } from '@backstage/core-components';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { RiBuildingLine, RiApps2Line, RiPuzzleLine } from '@remixicon/react';
import { appTranslationRef } from '../../core/i18n';
import styles from './create.page.module.css';

export const CreatePage = () => {
  const { t } = useTranslationRef(appTranslationRef);

  const tiles = [
    {
      icon: <RiBuildingLine />,
      title: t('create.tiles.client.title'),
      description: t('create.tiles.client.description'),
    },
    {
      icon: <RiApps2Line />,
      title: t('create.tiles.application.title'),
      description: t('create.tiles.application.description'),
    },
    {
      icon: <RiPuzzleLine />,
      title: t('create.tiles.component.title'),
      description: t('create.tiles.component.description'),
    },
  ];

  return (
    <Box className={styles.pageShell}>
      <HeaderPage title={t('create.pageTitle')} />
      <Content stretch>
        <Box className={styles.grid}>
          {tiles.map(tile => (
            <Box key={tile.title} className={styles.tile}>
              <Box className={styles.tileIcon}>{tile.icon}</Box>
              <Text variant="title-small">{tile.title}</Text>
              <Text variant="body-small" className={styles.tileDescription}>
                {tile.description}
              </Text>
            </Box>
          ))}
        </Box>
      </Content>
    </Box>
  );
};

